export enum SETTINGS {
  POMODORO = "1",
  BREAK = "2",
  LONG_BREAK = "3",
  CYCLES_TO_LONG_BREAK = "4",
  BREAKS_AUTO = "5",
  SESSION_AUTO = "6",
  NOTIFICATIONS = "7",
}
